import React from "react";
import {
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Line,
  ReferenceArea,
  ReferenceDot,
  Curve
} from "recharts";
import animations from "../util/animations";
import theme from "../theme";
const { colors } = theme.screen;

export default class extends React.Component {
  static defaultProps = {
    x: [-2, 2],
    y: [-0.5, 2.5],
    f: x => 0.8 + Math.sin(x),
    df: x => Math.cos(x),
    points: [],
    keyPoints: []
  };
  state = {};

  componentDidMount() {
    this.props.points.forEach(point => (point.id = undefined));
  }

  componentWillUnmount() {
    animations.remove(this);
  }

  render() {
    const {
      points,
      f,
      df,
      x: [xmin, xmax]
    } = this.props;
    points.forEach(point => {
      if (point.id) return;
      point.id = "id_" + Math.floor(100000000 * Math.random());
      point.f = f(point.x);
      point.df = df(point.x);
      if (point.step === 1) {
        animations.add(this, {
          key: point.id,
          min: 0,
          max: point.length,
          length: point.length * 3000
        });
      }
    });

    const dataPoint = x => {
      const obj = {
        x,
        f: f(x),
        zero: 0
      };
      points.forEach(({ id, x: p, f, df, step, length }) => {
        if (step >= 1) {
          const l = step === 1 ? this.state[id] || 0 : length;
          obj[id] = Math.abs(p - x) < l ? f + df * (x - p) : null;
        }
      });
      return obj;
    };

    const data = this.props.keyPoints.map(dataPoint);
    points.forEach(({ x, id, step, length }) => {
      const tLength = step === 1 ? this.state[id] : length;
      if (step >= 1) {
        data.push(dataPoint(x - tLength + 1e-6));
        data.push(dataPoint(x + tLength - 1e-6));
      }
    });
    const n = this.props.evalCount || 99;
    for (let i = 0; i <= n; ++i) {
      data.push(dataPoint(xmin + ((xmax - xmin) * i) / n));
    }
    data.sort(({ x: a }, { x: b }) => b - a);

    return (
      <div style={{ height: "100vh", maxHeight: "850px" }}>
        <ResponsiveContainer>
          <LineChart data={data} onMouseMove={this.props.onMouseMove}>
            <XAxis
              allowDataOverflow={true}
              dataKey="x"
              type="number"
              domain={[xmin, xmax]}
              hide={true}
            />
            <YAxis
              allowDataOverflow={true}
              type="number"
              ticks={[0]}
              domain={this.props.y}
            />
            <Line
              isAnimationActive={false}
              dataKey={"zero"}
              strokeWidth={2}
              stroke={"black"}
              dot={false}
            />
            <Line
              isAnimationActive={false}
              dataKey={"f"}
              strokeWidth={5}
              stroke={colors.primary}
              dot={false}
            />
            {points.map(({ id, x, color, f }) =>
              id ? (
                <ReferenceArea
                  key={"ra_" + id}
                  x1={x}
                  y1={0}
                  y2={f}
                  shape={({ x, y, height }) => (
                    <Curve
                      stroke={color || colors.extra[1]}
                      strokeDasharray="4 4"
                      strokeWidth="4"
                      points={[{ x, y }, { x, y: y + height }]}
                    />
                  )}
                />
              ) : null
            )}
            {points.map(({ id }) =>
              id ? (
                <Line
                  key={"li_" + id}
                  isAnimationActive={false}
                  dataKey={id}
                  strokeWidth={5}
                  stroke={colors.highlight}
                  dot={false}
                />
              ) : null
            )}
            {points.map(({ id, x, color }) =>
              id ? (
                <ReferenceDot
                  key={"rd_" + id}
                  x={x}
                  y={0}
                  fill={color || colors.extra[1]}
                />
              ) : null
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
